<script>
import {httpAction, postAction} from "../../../utils/api/manages";

export default {
  name: "expert",
  props: {
    productCategoryId: String,
  },
  watch: {
    productCategoryId(val) {
      this.getExpertList()
    }
  },
  created() {
    this.getExpertList()
  },
  data() {
    return {
      expertList: [],
      isLoading: false,
    }
  },
  methods: {
    // 获取专家列表
    getExpertList() {
      this.isLoading = true
      httpAction({
        url: '/expert/list',
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 5,
          productCategoryId: this.productCategoryId
        },
        noToken: true,
      }).then(res => {
        this.expertList = res.data
      }).finally(() => {
        this.isLoading = false
      })
    },
    // 添加好友
    addFollow(item) {
      const isLogin = localStorage.getItem("showLogin")
      if (isLogin === '0') {
        layer.alert('请先登录', {icon: 6})
        return
      }
      const userInfo = JSON.parse(localStorage.getItem("authdata"))
      const {userId} = userInfo.data
      const applyTargetUserid = item.userId
      const data = {
        applyTargetUserid,
        userid: userId,
        content: ''
      }
      postAction('/message/applyfirends', data).then(res => {
        if (res.code !== 200) return
        layer.alert('加好友申请成功！<br/>留意系统通知耐心等待通过', {icon: 6})
      }).catch(res => {
        layer.alert(res.msg)
      })
    },
  }
}
</script>

<template>
  <div class="expert">
    <div class="expert-head">
      <div class="title">专家列表</div>
      <div class="myBtn el-icon-circle-plus" @click="$router.push('/expert')">专家申请</div>
    </div>
    <div class="expert-body" v-loading="isLoading">
      <template v-if="expertList.length">
        <div class="card" v-for="(item,index) in expertList" :key="index">
          <div class="info-img">
            <el-image :src="item.expertImages" class="imgBox" fit="cover"></el-image>
            <div class="myBtn" @click="$router.push(`/expert-info?expertId=${item.expertId}`)">聊他</div>
          </div>
          <div class="info-content">
            <div class="content-head">
              <div class="head-left">
                <div class="name" :title="item.createBy">{{ item.createBy.slice(0,3) }}</div>
                <div class="post ellipsis" :title="item.station">{{ item.station }}</div>
              </div>
              <div class="myBtn el-icon-plus" @click="addFollow(item)">好友</div>
            </div>
            <div class="content-body">
              <div class="industry ellipsis">{{ item.industryName }}</div>
              <div class="el-icon-location-outline address">
                {{ item.areaNames.split('/').at(-1) }}
              </div>
            </div>
            <div class="company el-icon-office-building ellipsis"> {{ item.curWorkAddress || '暂无' }}</div>
          </div>
        </div>
      </template>
      <div class="empty" v-else>暂无内容</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.expert {
  padding: 15px 15px 20px;
  background: #f2f2e5;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .myBtn {
    cursor: pointer;
    color: var(--swiper-theme-color);
  }

  .expert-head {
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;
    margin-bottom: 15px;

    &:after {
      content: '';
      display: block;
      height: 100%;
      width: 4px;
      position: absolute;
      left: 0;
      background-color: var(--swiper-theme-color);
      border-radius: 4px;
    }

    .title {
      font-size: 16px;
      color: #232f3e;
      padding-left: 15px;
      font-weight: bold;
    }
  }

  .expert-body {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .card {
      flex: 1;
      background-color: #fff;
      border-radius: 6px;
      border: 1px solid transparent;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 10px;
      display: flex;
      gap: 10px;
      cursor: pointer;

      &:hover {
        border-color: rgb(2, 98, 241);
      }

      .info-img {
        width: 60px;
        text-align: center;
        flex-shrink: 0;

        .imgBox {
          width: 100%;
          height: 75px;
          border-radius: 4px;
          overflow: hidden;
          display: block;
          margin-bottom: 4px;
        }
      }

      .info-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
        overflow: hidden;

        .content-head {
          display: flex;
          align-items: center;
          gap: 5px;
          width: 100%;
          justify-content: space-between;
          .head-left{
            display: flex;
            align-items: center;
          }

          .name {
            // width: calc(100% / 3);
            font-size: 16px;
            line-height: 1em;
            font-weight: 500;
            color: #232F3E;
          }

          .post {
            // width: calc(100% / 3);
            width: 60px;
            font-size: 12px;
            color: #999999;
            margin-left: 5px;
          }

          .myBtn {
            // width: calc(100% / 3);
            text-align: right;
          }
        }

        .content-body {
          font-size: 12px;
          color: #999999;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 5px;


          .industry {
            width: 70%;
          }

          .address {
            width: 31%;
            text-align: right;
          }
        }

        .company {
          flex: 1;
          width: 180px;
          color: #999999;
        }
      }
    }

    .empty {
      text-align: center;
      line-height: 40px;
      color: #999999;
    }
  }
}

</style>